import { combineReducers, applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { type PlatformApi } from '@app/external/common/controller/platform-api';
import { type AppStore, type ControllerConfig, type FlowAPI } from '@app/external/common/types';
import commonReducers from '../../common/reducers';
import archiveWidgetReducer from '../aggregated-archive/reducer';
import { type ArchiveThunkArgs } from '../types';

export function createReduxStore({
  appParams,
  platformApi,
  compId,
  flowAPI,
}: {
  appParams: ControllerConfig['appParams'];
  platformApi: PlatformApi;
  compId: ControllerConfig['compId'];
  bundleName: string;
  flowAPI: FlowAPI;
}) {
  const middleware = [
    thunk.withExtraArgument({
      compId,
      appParams,
      panoramaClient: flowAPI.panoramaClient,
      httpClient: flowAPI.httpClient,
      errorHandler: flowAPI.errorHandler,
      flowAPI,
      platformApi,
    } satisfies ArchiveThunkArgs),
  ];

  const reducers = combineReducers({
    ...commonReducers,
    archiveWidget: archiveWidgetReducer,
  });

  const initialState = { experiments: flowAPI.essentials.experiments.all() };

  return createStore(reducers, initialState, applyMiddleware(...middleware)) as unknown as AppStore;
}
